/* eslint-disable jsx-a11y/label-has-for */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import { compose } from 'redux';
import { useIntl } from 'react-intl';

import { MAX_DATE_DELIVERY_DELTA } from '../../constants';
import { formMessages } from '../../defineMessages';

// eslint-disable-next-line css-modules/no-unused-class
import s from './DateTimeInput.scss';
// eslint-disable-next-line css-modules/no-unused-class
import { isDateInPast } from '../../helpers/date';

const getDateInputString = date => {
  const day = `0${date.getDate()}`.slice(-2);
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const minutes = `0${date.getMinutes()}`.slice(-2);

  return `${date.getFullYear()}-${month}-${day}T${date.getHours()}:${minutes}:00.000`;
};

const DateTimeInput = ({
  initialValue,
  showLabel,
  fluid,
  required,
  onChange,
}) => {
  const { formatMessage } = useIntl();
  const now = new Date();
  const today = getDateInputString(now);

  const selectedDateTime =
    !initialValue || isDateInPast(initialValue)
      ? today
      : getDateInputString(new Date(initialValue));

  const [state, setState] = useState({
    selectedDateTime,
    hasError: null,
  });

  const classes = cx(s.root, s.wrapper, fluid && s.fluid);

  const labelClass = cx(
    showLabel ? s.label : 'visually-hidden',
    required && s.required,
  );

  const maximumDate = new Date();
  maximumDate.setTime(maximumDate.getTime() + MAX_DATE_DELIVERY_DELTA);
  const maxDeliveryDate = getDateInputString(maximumDate);

  const dateIsValid = date => {
    if (!date) {
      setState({
        ...state,
        hasError: {
          message: formatMessage({ ...formMessages.required }),
        },
      });
      return false;
    }

    if (isDateInPast(new Date(date))) {
      setState({
        ...state,
        hasError: {
          message: formatMessage({ ...formMessages.past_date_error }),
        },
      });
      return false;
    }
    return true;
  };

  const handleTimeChange = e => {
    if (!dateIsValid(e.target.value)) return;
    setState({ selectedDateTime: e.target.value, hasError: null });
    onChange(new Date(e.target.value).toISOString());
  };

  const showPicker = () => {
    const input = document.querySelector(
      'input[type="datetime-local"][name="datetime"]',
    );
    try {
      input.showPicker();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={s.wrapper}>
      <label
        className={cx(classes, state.hasError && s.error)}
        htmlFor="datetime"
      >
        {showLabel && (
          <span className={labelClass}>
            {formatMessage({ ...formMessages.date })}
          </span>
        )}
        <input
          name="datetime"
          type="datetime-local"
          className={cx(s.input, state.hasError && s.hasError)}
          value={state.selectedDateTime}
          onChange={e => handleTimeChange(e)}
          min={today}
          max={maxDeliveryDate}
          required
          onClick={showPicker}
        />
        {state.hasError && (
          <span className={s.error}>{state.hasError.message}</span>
        )}
      </label>
    </div>
  );
};

DateTimeInput.propTypes = {
  initialValue: PropTypes.string,
  showLabel: PropTypes.bool,
  required: PropTypes.bool,
  fluid: PropTypes.bool,
  onChange: PropTypes.func,
};

DateTimeInput.defaultProps = {
  initialValue: null,
  showLabel: false,
  fluid: false,
  onChange: () => null,
  required: false,
};

export default compose(withStyles(s))(DateTimeInput);
